import httpService from "./httpService.js"

export const getAllPaymentsService = (page, limit, q, status) => {
    return httpService(`/payment/payment_admin_panel/?page=${page}&limit=${limit}${status ? `&status=${status}` : ""}${q ? `&q=${q}` : ""}`, "get");
}

export const getSinglePaymentService = (paymentId) => {
    return httpService(`/payment/payment_admin_panel/${paymentId}/`, "get");
}
